export default {"src":"/_next/static/media/chart-bar.e401ffd4.svg","height":20,"width":20};